module.exports = __webpack_public_path__ + "img/map.0634cd11.png";